import React, { useRef, useEffect } from "react";
import DropdownComponent from "../../../containers/Dropdown";
import { SERVICETYPEDRPDATA, ALERT_ERROR_MESSAGE } from "../../../App.config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Wheelchair from "../../../images/wheelchair.svg";
import heart from "../../../images/heart.svg";
import AlertError from "../../../containers/Common/AlertError";
import moment from "moment";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";
import ApplicationFilter from "../../../containers/ApplicationFilter";

const EmployerStatement = ({
  state,
  handleChanges,
  onDropDownChange,
  onSubmit,
  props,
  onDateChange,
  onDiscard,
  onSearchClick,
  isFormValid,
  onFilterDrpChange,
  onFilterDropDownChange
}) => {
  // Set focus on element after first render
  useEffect(() => {
    if (state.firstName.ref.current.focus) {
      state.firstName.ref.current.focus();
    }
  }, []);
  return (
    <>
      {/* {!isFormValid && <AlertError message={ALERT_ERROR_MESSAGE} />} */}
      <div className="Dashboard-Content">

        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <div className="p-img">
                <img src={heart} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t("STD-Employer-Statement.form.heading.text")}
                </span>
                {/* <legend>
                  {props.context.t(
                    "STD-Employer-Statement.form.subheading.text"
                  )}
                </legend> */}
              </h2>
            </div>
            {/* {props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature &&  */}
            <ApplicationFilter selectedFilterValue={state.selectedFilterValue}
              context={props.context}
              onFilterDropDownChange={onFilterDropDownChange} onFilterDrpChange={onFilterDrpChange} />
            {/* } */}
            {state.isEnableSearch.value ? (
              <div className="Panel-search">
                <form action="">
                  <div className="Search-check-box">
                    <div className="form-group">
                      <label htmlFor="">Search Employee</label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-Last-Name"
                              name="searchBy"
                              value="LastName"
                              checked={state.searchBy.value === "LastName"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Last-Name">By Last Name</label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-EIN"
                              name="searchBy"
                              value="EIN"
                              checked={state.searchBy.value === "EIN"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-EIN">By EIN</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-9">
                      <div className="Search-empl">
                        {state.isSearchByLastName.value ? (
                          <DropdownComponent
                            name="clientInfo"
                            id="clientInfo"
                            options={props.clientInfo}
                            isMultiSelect={false}
                            option_key="clientId"
                            option_display="fullName"
                            onChange={onDropDownChange}
                            values={state.clientInfo.value}
                            simplePlaceholder="--Select Employee--"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          />
                        ) : (
                          <div className="form-group">
                            <label htmlFor="">
                              {props.context.t("CurrentActivity.Search.Text")}
                            </label>
                            <input
                              type="text"
                              name="searchValue"
                              onChange={handleChanges}
                              value={state.searchValue.value}
                              placeholder="Search Employee By EIN"
                            />
                            <input
                              type="submit"
                              onClick={(e) => {
                                e.preventDefault();
                                onSearchClick();
                              }}
                              value="Search"
                            />
                            {state.searchValue?.error && (
                              <span className="error">
                                {state.searchValue.error}
                              </span>
                            )}
                          </div>
                        )}
                        {props.isSearch && (
                          <input
                            type="button"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              onDiscard();
                            }}
                            value="Discard"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            ) : null}
            <div className="panel-content">
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.label.text.FirstName"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        ref={state.firstName.ref}
                        value={state.firstName.value}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        readOnly={!state.firstName.isEditable}
                      />
                      {state.firstName?.error && (
                        <span className="error">{state.firstName.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.label.text.LastName"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={state.lastName.value}
                        ref={state.lastName.ref}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        readOnly={!state.lastName.isEditable}
                      />
                      {state.lastName?.error && (
                        <span className="error">{state.lastName.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.label.text.Employee-ID/EIN"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="ein"
                        ref={state.ein.ref}
                        value={state.ein.value}
                        onChange={handleChanges}
                        readOnly={!state.ein.isEditable}
                      />
                      {/* <small className="hint">Hint : Minimum 9 characters</small> */}
                      {state.ein?.error && (
                        <span className="error">{state.ein.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.calender.text.Birth-Date"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        id="dateOfBirth"
                        readOnly={!state.dateOfBirth.isEditable}
                        selected={state.dateOfBirth.value}
                        onChange={(e) => {
                          if (state.dateOfBirth.isEditable) {
                            onDateChange(e, "dateOfBirth");
                          }
                        }}
                        maxDate={moment().toDate()}
                        ref={state.dateOfBirth.ref}
                        className="form-control"
                        placeholderText={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.calender.PlaceHolder.Common.DatePicker"
                        )}
                        dropdownMode="select"
                      />
                      {state.dateOfBirth?.error && (
                        <span className="error">{state.dateOfBirth.error}</span>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.label.text.serviceType"
                        )}
                      </label>
                      <span size="5" className="error-star">
                        *
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="serviceType"
                        ref={state.serviceType.ref}
                        value={state.serviceType.value}
                        readOnly={true}
                      />
                      {state.serviceType?.error && (
                        <span className="error">
                          {state.serviceType.error}
                        </span>
                      )}
                      {/* <div className="Custom-select">

                        <DropdownComponent
                          name="serviceType"
                          id="serviceType"
                          options={SERVICETYPEDRPDATA}
                          isMultiSelect={false}
                          option_key="serviceTypeId"
                          option_display="serviceType"
                          onChange={onDropDownChange}
                          values={state.serviceType.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          isSearchOption={true}
                          ref={state.serviceType.ref}
                        />
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="panel-footer text-right margn-50">
                  <a
                    tabIndex="0"
                    className="btn btn-primary"
                    onClick={onSubmit}
                  >
                    {props.context.t(
                      "STD-Employer-Statement.form.button.save-and-move-next-step.title"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployerStatement;
